// extracted by mini-css-extract-plugin
export default {"page":"Page_page__Q6WLM","page_title":"Page_page_title__eRq7+"};